module.exports = __webpack_public_path__ + "media/images/emblems/Cortaillod-blason-4d8f3a51e16adcb897703239613c82c1.png";